import ImageWithAttribution from './imageWithAttribution.component';

export default ImageWithAttribution;
